export default __webpack_public_path__ + "static/logo-7fcad484b1900e3e20046452095e74fd.png";